import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
// @mui/material components
import { useTheme } from "@mui/material/styles";
import { AppBar, Toolbar, IconButton, Typography, Box, Tooltip, useMediaQuery } from "@mui/material";
import { baseUrl } from '../../components/shared/baseUrl';
// @mui/icons-material
import MenuIcon from "@mui/icons-material/Menu";
// core components
import AdminNavbarLinks from "./AdminNavbarLinks.jsx";



const styles = (theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  }
  ,
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    }
  },
  itemIcon: {
    width: "25px",
    height: "30px",
    fontSize: "10px",
    lineHeight: "10px",
    float: "left",
    marginRight: "5px",
    textAlign: "center",
    verticalAlign: "middle",
    color: "rgba(" + '#FFF' + ", 0.8)"
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  root: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  }

});



export default function Header(props) {
  const { color, routes, type, lay, handleDrawerToggle } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const classes = styles(theme);
 
  const activeRoute = (routeName) =>
    window.location.href.indexOf(routeName) > -1;


      const RenderLinks = () =>
        routes
          .filter((prop) => prop.layout === lay && prop.icon !== "None")
          .map((prop, key) => {
            const isActive = activeRoute(prop.layout + prop.path);
            return (
              <NavLink
                to={`${prop.layout}${prop.path}`}
                key={key}
                style={{
                  textDecoration: "none",
                  color: isActive ? "brown" : "#FFF",
                  marginLeft: theme.spacing(3),
                  display: "flex",
                  alignItems: "center"
                }}
              >
                {typeof prop.icon === "string" ? (
                  <Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
                    <span className="material-icons" style={{ marginRight: 5 }}>{prop.icon}</span>
                    {prop.name}
                  </Typography>
                ) : (
                  <Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
                    <prop.icon sx={{ marginRight: 1 }} />
                    {prop.name}
                  </Typography>
                )}
              </NavLink>
        );
      });

  return (
    <AppBar position="static" color={color || "primary"}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        {/* Logo on the left */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <Tooltip title="Go to CT-Onlinq home" arrow placement="bottom">
            <img
              alt="CT-Onlinq"
              src={`${baseUrl}assets/images/myLogo.jpg`}
              style={{
                height: 50,
                borderRadius: 10,
                border: "1px solid #6e8bff",
                marginRight: theme.spacing(2),
              }}
            />
          </Tooltip>
        </Box>

        {/* Navigation Links */}
        <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 1 }}>
          <RenderLinks />
          <AdminNavbarLinks routes={routes} type={type} />
        </Box>

        {/* Mobile Menu Icon */}
        {isMobile && (
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
            //sx={{ display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object)
};
